<template>

  <section>
    <van-row class="banner-panel" v-if="gameInfo['showDown']===2">
      <img :src="entityFileMain+'/'+gameInfo['noDownPage']"/>
    </van-row>
    <van-row v-if="gameInfo['showDown']===1">
      <van-row class="banner-panel" v-if="this.isSetString(gameInfo['landingPage'])">
        <img :src="entityFileMain+'/'+gameInfo['landingPage']"/>
      </van-row>
      <van-row class="icon-panel">
        <van-col class="icon">
          <img :src="entityFileMain+'/'+gameInfo['gameIcon']"/>
        </van-col>
        <van-col class="content">
          <van-row class="name">{{ gameInfo['gameName'] }}</van-row>
          <van-row class="tag">
            <span v-if="this.isSetString(gameInfo['tagOne'])">{{ gameInfo['tagOne'] }}</span>
            <span v-if="this.isSetString(gameInfo['tagTwo'])">{{ gameInfo['tagTwo'] }}</span>
            <span v-if="this.isSetString(gameInfo['tagThree'])">{{ gameInfo['tagThree'] }}</span>
          </van-row>
          <van-row class="info"><span>{{ gameInfo['downloads'] }}</span>人在玩</van-row>
          <van-row class="btns">
            <div class="item" @click="playH5Game();" v-if="this.isSetString(gameInfo['isH5'])">开始游戏</div>
            <div class="item download" @click="downloadGame();">下载游戏</div>
          </van-row>
        </van-col>
      </van-row>
      <van-row class="game-about">
        <van-row class="title">游戏简介</van-row>
        <van-row :class="['content',isMore&&'show']">
          <div v-html="gameInfo['describe']"></div>
          <div class="more" v-if="!isMore" @click="handleMore"><span>...</span>更多</div>
        </van-row>
        <van-row class="pic-view">
          <div class="item" v-for="(item,index) in gameInfo['screenshot']" :key="index"
               @click="handlePreview(index)">
            <img :src="entityFileMain+'/'+item"/>
          </div>
        </van-row>
      </van-row>
      <van-row class="footer-panel">
        <van-col class="icon">
          <img :src="entityFileMain+'/'+gameInfo['gameIcon']"/>
        </van-col>
        <van-col class="name">{{ gameInfo['gameName'] }}</van-col>
        <van-col class="btns">
          <div class="download" @click="downloadGame()">下载游戏</div>
        </van-col>
      </van-row>
    </van-row>

    <!-- 注册 -->
    <van-dialog v-model="isRegister" title="用户中心" :show-confirm-button="false">
      <div class="form-close" @click="isLogin=isRegister=false">
        <img src="../../assets/images/icon/close.png"/>
      </div>
      <van-row class="form-register">
        <van-row class="item">
          <van-col class="icon">
            <img src="../../assets/images/icon/accout.png"/>
          </van-col>
          <van-col class="content">
            <input v-model="form.userName" placeholder="字母开头，5-16位数字或字母"/>
          </van-col>
        </van-row>
        <van-row class="item">
          <van-col class="icon">
            <img src="../../assets/images/icon/password.png"/>
          </van-col>
          <van-col class="content">
            <input type="password" v-model="form.password" placeholder="请输入密码"/>
          </van-col>
        </van-row>
        <van-row class="item">
          <van-col class="icon">
            <img src="../../assets/images/icon/password.png"/>
          </van-col>
          <van-col class="content">
            <input type="password" v-model="form.rePassword" placeholder="请重新输入密码"/>
          </van-col>
        </van-row>
      </van-row>
      <van-row class="form-button">
        <van-button type="primary" @click="handleConfirm(1)">立即注册</van-button>
      </van-row>
      <van-row class="other-tips"><a @click="openUserDialog(1)">用户登录</a></van-row>
    </van-dialog>
    <!-- 登录 -->
    <van-dialog v-model="isLogin" title="用户中心" :show-confirm-button="false">
      <div class="form-close" @click="isLogin=isRegister=false">
        <img src="../../assets/images/icon/close.png"/>
      </div>
      <van-row class="form-register">
        <van-row class="item">
          <van-col class="icon">
            <img src="../../assets/images/icon/accout.png"/>
          </van-col>
          <van-col class="content">
            <input v-model="form.userName" placeholder="请输入账号"/>
          </van-col>
        </van-row>
        <van-row class="item">
          <van-col class="icon">
            <img src="../../assets/images/icon/password.png"/>
          </van-col>
          <van-col class="content">
            <input type="password" v-model="form.password" placeholder="请输入密码"/>
          </van-col>
        </van-row>
      </van-row>
      <van-row class="form-button">
        <van-button type="primary" @click="handleConfirm(2)">立即登录</van-button>
      </van-row>
      <van-row class="other-tips"><a @click="openUserDialog(2)">用户注册</a></van-row>
    </van-dialog>

    <!-- 苹果企业签设置讲解 -->
    <div class="plist-container" v-show="showPlistTips">
      <img src="../../assets/images/plist_wx_flow.jpg" class="wx_flow_img">
    </div>

    <!-- 隐藏显示  微信下载页去跳转 -->
    <div class="wx-tips-div" v-show="showWXTips">
      <img src="../../assets/images/wx_tips.jpg"/>
    </div>
  </section>
</template>


<script>

import {ImagePreview} from 'vant';
import {WxFeatures} from '../../assets/js/wxFeatures.js'

export default {
  data() {
    return {
      isMore: false,
      isRegister: false,
      isLogin: false,
      showPlistTips: false,
      showWXTips: false,
      mRunRomSystem: "android",
      chData: '',
      defaultData: "NTdicjY4NWJy",
      form: {
        userName: '',
        password: '',
        rePassword: ''
      },
      entityFileMain: "",
      gameInfo: {},
      wxData: {},
      gameDownloadUrl: '',
    }
  },
  created() {
    this.getLoad();
  },
  methods: {
    //初始化加载
    getLoad() {
      this.chData = this.$route.query.ch;
      this.mRunRomSystem = this.runRomSystem();
      let params = {
        chData: this.chData ? this.chData : this.defaultData,
        reqSys: "wapWeb",
        runRomSys: this.mRunRomSystem,
        mUrl: encodeURIComponent(self.location.href)
      }
      this.$http(window.config.webHomeApiV2 + '/tg/game_info', params).then((res) => {
        let code = res['code'];
        if (code !== 1) {
          this.BRDialog("提示", res['msg']);
          return;
        }
        let resData = res['data'];
        this.entityFileMain = resData['entityUrl'];
        this.gameInfo = resData['gameData'];
        this.wxData = resData['wxData'];
        let gameName = this.gameInfo['gameName'];
        let gameIcon = this.entityFileMain + "/" + this.gameInfo['gameIcon'];
        let gameDes = this.gameInfo['shortDescribe'];
        let wxShareData = resData['wxData'];
        this.WxFeatures(wxShareData, gameName, gameIcon, gameDes);
      })
    },
    //更多
    handleMore() {
      this.isMore = true;
    },
    //查看图片
    handlePreview(key) {
      let images = this.gameInfo['screenshot'].map(item => {
        return this.entityFileMain + '/' + item;
      })
      ImagePreview({
        images: images,
        startPosition: key
      });
    },

    //下载游戏
    downloadGame() {
      if (this.isRunInWeChatApp()) {
        this.showWXTips = true;
        return false;
      }
      let params = {
        chData: this.chData ? this.chData : this.defaultData,
        reqSys: "wapWeb",
        runRomSys: this.mRunRomSystem,
      }
      this.$http(window.config.webHomeApiV2 + '/tg/game_download', params).then((res) => {

        let code = res['code'];
        if (code !== 1) {
          this.BRDialog("提示", res['msg']);
          return;
        }
        let resData = res['data'];
        let downLoadType = resData['downLoadType'];
        this.gameDownloadUrl = resData['downloadUrl'];
        switch (downLoadType) {
          case 1:
            if (this.mRunRomSystem == "ios") {
              this.showPlistTips = true;
            }
            window.location.href = this.gameDownloadUrl;
            break;
          case 2:
            document.location.href = this.gameDownloadUrl;
            break;
          default:
            this.isRegister = true;
            break;
        }
      });
    },
    //H5在线玩
    playH5Game() {
      if (this.isRunInWeChatApp()) {
        this.showWXTips = true;
        return false;
      }
      let params = {
        chData: this.chData ? this.chData : this.defaultData,
        reqSys: "wapWeb",
        runRomSys: this.mRunRomSystem,
      }
      this.$http(window.config.webHomeApiV2 + '/tg/game_play_h5', params).then((res) => {
        let code = res['code'];
        if (code !== 1) {
          this.BRDialog("提示", res['msg']);
          return;
        }
        let resData = res['data'];
        window.location.href = resData['playUrl'];
      });

    },

    WxFeatures: function (wxShareData, gameName, gameIcon, gameDes) {
      new WxFeatures({
        wxConfig: wxShareData,
        wxTitle: gameName,
        wxLink: location.href,
        wxImgUrl: gameIcon,
        wxDesc: gameDes,
        wxType: '',
        wxDataUrl: ''
      });
    },


    //用户中心确认   1为注册 ，2为登录
    handleConfirm(type) {
      if (!this.form.userName) {
        this.BRToast('请输入账号');
        return false;
      }
      if (!this.form.password) {
        this.BRToast('请输入密码');
        return false;
      }
      if (type == 1) {
        this.doRegister();
      } else {
        this.doLogin();
      }
    },

    doRegister() {
      if (this.form.password != this.form.rePassword) {
        this.BRToast('两次密码输入不一致，请重新输入');
        return false;
      }
      let params = {
        chData: this.chData ? this.chData : this.defaultData,
        ...this.form,
        reqSys: "wapWeb",
        runRomSys: this.mRunRomSystem,
      }
      this.$http(window.config.userHomeApi + '/tg/register/user_name', params).then((res) => {
        document.location.href = this.gameDownloadUrl;
        this.isRegister = false;
      });
    },

    doLogin() {
      let params = {
        chData: this.chData ? this.chData : this.defaultData,
        ...this.form,
        reqSys: "wapWeb",
        runRomSys: this.mRunRomSystem,
      }
      this.$http(window.config.userHomeApi + '/tg/login/user_name', params).then((res) => {
        document.location.href = this.gameDownloadUrl;
        this.isLogin = false;
      });
    },

    //切换弹框
    openUserDialog(type) {
      Object.keys(this.form).forEach(key => {
        this.form[key] = '';
      })
      if (type == 1) {
        this.isRegister = false;
        this.isLogin = true;
      } else {
        this.isRegister = true;
        this.isLogin = false;
      }
    }
  }
};
</script>


<style scoped lang='less'>
@import "../../assets/css/home/index.less";
</style>


<style scoped lang='less'>
.plist-container {
  position: fixed;
  z-index: 1;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: #fff;
  overflow: auto;
}

.plist-container img {
  width: 100%;
}

.wx_flow_img {
  position: absolute;
  top: 0px;
  left: 0;
}
</style>

<style scoped lang='less'>
.wx-tips-div {
  position: fixed;
  z-index: 1;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: #fff;
}

.wx-tips-div img {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// game.vue?3ca1b4e1